/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 28.01.25
 *
 */
import {asArray, uuidv4} from "@/utils/helpers";
import dayjs from "dayjs";
import {AgeDateDisplayEnum} from "@shared/Genogram/AgeDateDisplayEnum";


export const GenogramEnum = Object.freeze({
	CREATE_PARTNER: "create_partner"
})

export const createAuxNode = ({parentEdge, childNode, x, xPositionPercent}) => {
	const auxNodeId = 'aux_' + uuidv4();

	let auxNodesParent = getData(parentEdge).auxNodes || [];
	auxNodesParent.push(auxNodeId)
	setData(parentEdge, {auxNodes: auxNodesParent})

	let auxNodesChild = getData(childNode).auxNodes || [];
	auxNodesChild.push(auxNodeId)
	setData(childNode, {auxNodes: auxNodesChild})


	return {
		data: {
			isAuxNode: true,
			parentEdgeId: getData(parentEdge).id || null,
			childNodeId: getData(childNode).id || null,
			// xPositionPercent: xPositionPercent,
			type: 'round-rectangle',
			name: '',
			resize: true,
			width: 10,
			height: 10,
			id: auxNodeId,
			skipSnapToGridY: true,
		},
		position: {
			x: x,
			// y: y1,
		},
	};
}

export function prepareCopyAuxNodes(nodes, _oldIdToNewId) {
	let nodesLocal = asArray(nodes)
	console.log("prepareCopyAuxNodes: nodesLocal = ", nodesLocal)
	nodesLocal.forEach(node => {
		// if (!node || !getData(node, 'isAuxNode')) return;
		const data = getData(node)
		console.log("prepareCopyAuxNodes: data = ", data)
		if (data.parentEdgeId && _oldIdToNewId[data.parentEdgeId]) {
			data.parentEdgeId = _oldIdToNewId[data.parentEdgeId];
		}
		if (data.childNodeId && _oldIdToNewId[data.childNodeId]) {
			data.childNodeId = _oldIdToNewId[data.childNodeId];
		}
		if(Array.isArray(data.auxNodes)){
			data.auxNodes = data.auxNodes.map(auxNodeId => _oldIdToNewId[auxNodeId])
		}
	});
	return nodes;
}

export function nonempty(node){
	if(!node){
		return false
	}
	if(typeof node.data === "function") {
		return node.nonempty()
	}
	return true
}

export function getPosition(node){
	if(!node){
		return
	}
	if(typeof node.position === "function") {
		return node.position()
	}
	return node.position
}
export function setPosition(node, position){
	if(typeof node.position === "function") {
		node.position(position)
	} else {
		node.position = node.position || {}
		if(position.x != null){
			node.position.x = position.x
		}
		if(position.y != null){
			node.position.y = position.y
		}
	}
}
export function getData(node, key){
	if(typeof node.data === "function") {
		return node.data(key)
	}
	return key ? node.data[key] : node.data
}

export function setData(node, data){
	if(typeof node.data === "function") {
		node.data(data)
	} else {
		node.data = node.data || {}
		node.data = {
			...node.data,
			...data
		}
	}
}


function asDataFn(elem){
	let data = elem.data
	if(typeof data === "object"){
		data = (params) => {
			if(params){
				elem.data = {
					...elem.data,
					...params
				}
			} else {
				return elem.data
			}
		}
	} else {
		data = (args) => elem.data(args)
	}
	return data
}

export function syncNodeLabel(nodeData, options = {}) {
	options.ageDateDisplay = options.ageDateDisplay || AgeDateDisplayEnum.FULL
	let age = null
	let dateOfBirth = null
	let dateOfDeath = null
	if (nodeData.dateOfBirth) {
		let rightDate = dayjs()
		if (nodeData.isPassedAway && nodeData.dateOfDeath) {
			rightDate = dayjs(nodeData.dateOfDeath)
		}
		age = rightDate.diff(dayjs(nodeData.dateOfBirth), 'year')
	}
	if (nodeData.dateOfBirth) {
		dateOfBirth = "Born: " + dayjs(nodeData.dateOfBirth).format(nodeData.birthFormat || "MMM DD, YYYY")
	}
	if (nodeData.isPassedAway && nodeData.dateOfDeath) {
		let text = ""
		if(nodeData.dateOfBirth && age && age <= 0){
			text = "Stillbirth or miscarriage: "
		} else {
			text = "Passed away: "
		}
		dateOfDeath = text + dayjs(nodeData.dateOfDeath).format(nodeData.deathFormat || "MMM DD, YYYY")
	}
	if(age !== null){
		if (age === 0) {
			age = 'Infant'
		} else {
			age = age + " y.o."
		}
	}
	switch (options.ageDateDisplay) {
		case AgeDateDisplayEnum.AGE_ONLY:
			dateOfBirth = null
			break
		case AgeDateDisplayEnum.DATE_ONLY:
			age = null
			break
		case AgeDateDisplayEnum.FULL:
			break
	}
	let notePublic = nodeData.notePublic ? "\n" + nodeData.notePublic : null
	let textLine = [nodeData.relationship, nodeData.gender, age].filter(item => !!item).join(", ")
	nodeData.label = [nodeData.name, textLine, dateOfBirth, dateOfDeath, notePublic].filter(item => !!item).join(",\n")
}
